import { config } from '@/config';
import { FILE_EXTENSIONS } from './consts.ts';
import { FileExtension, FileInfo } from './types.ts';

export async function checkFileExtension(
  fileName: string,
  id: string,
): Promise<keyof typeof FILE_EXTENSIONS | undefined> {
  if (!fileName) return undefined;
  let ext = fileName?.split('.').pop();
  ext = Object.values(FILE_EXTENSIONS).find((el) => el === ext);
  if (ext === undefined) {
    const resp = await fetch(`${config.filestorage}/file-data/${id}`);
    const result: FileInfo = await resp.json();
    if (result.name === undefined) return undefined;
    return result.name?.split('.').pop() as FileExtension;
  } else {
    return ext as FileExtension;
  }
}
